var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgangeEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60389 5.03071C9.60389 5.63717 9.36298 6.2188 8.93414 6.64764C8.5053 7.07648 7.92367 7.31739 7.31721 7.31739C6.71074 7.31739 6.12911 7.07648 5.70027 6.64764C5.27144 6.2188 5.03052 5.63717 5.03052 5.03071C5.03052 4.42424 5.27144 3.84261 5.70027 3.41377C6.12911 2.98494 6.71074 2.74402 7.31721 2.74402C7.92367 2.74402 8.5053 2.98494 8.93414 3.41377C9.36298 3.84261 9.60389 4.42424 9.60389 5.03071Z",
    fill: "#FCB248"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.03071C0 5.03071 2.74403 0 7.3174 0C11.8908 0 14.6348 5.03071 14.6348 5.03071C14.6348 5.03071 11.8908 10.0614 7.3174 10.0614C2.74403 10.0614 0 5.03071 0 5.03071ZM7.3174 8.23208C8.16646 8.23208 8.98074 7.89479 9.58111 7.29442C10.1815 6.69405 10.5188 5.87977 10.5188 5.03071C10.5188 4.18166 10.1815 3.36738 9.58111 2.76701C8.98074 2.16664 8.16646 1.82935 7.3174 1.82935C6.46835 1.82935 5.65407 2.16664 5.0537 2.76701C4.45332 3.36738 4.11604 4.18166 4.11604 5.03071C4.11604 5.87977 4.45332 6.69405 5.0537 7.29442C5.65407 7.89479 6.46835 8.23208 7.3174 8.23208Z",
    fill: "#FCB248"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgangeEyeIcon);
export default __webpack_public_path__ + "static/media/OrgangeEyeIcon.a1b03e3e3d5b9724020cabfc4667e053.svg";
export { ForwardRef as ReactComponent };